import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsPrepareTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['prepare']> = {
  zh: {
    lockedTitle: '准备你的商品',
    lockedDescription: '获得完整的商品准备教程，包括耗材采购、商品包装、条码打印、箱唛粘贴等。确保商品以最低成本完成跨境准备，避免在海外产生额外费用。',
    lockedFeature1: '包装材料采购清单和规格',
    lockedFeature2: '标准化商品包装流程',
    lockedFeature3: 'OMS商品信息录入指引',
    lockedFeature4: '入库单和箱唛打印操作',
    actionOpenAccount: '立即开户',
    actionContact: '联系客服',
    cardPurchaseTitle: '采购耗材',
    notePurchase: '海外人工和耗材成本极高，请在国内完成所有包装工作，让海外仓只承担最基础的商品收发工作。',
    packagingMaterialsTitle: '包装材料',
    packagingMaterialsDescription: '用于包装商品，请按需采购。确保包装硬挺不易弯折，且至少有一个面大于15×10cm。',
    packagingMaterialsItem1: '不透明纸箱',
    packagingMaterialsItem2: '不透明信封',
    packagingMaterialsItem3: '不透明气泡袋',
    packagingMaterialsItem4: '不透明快递袋（不推荐）',
    logisticsBoxTitle: '物流纸箱',
    logisticsBoxDescription: '用于国际物流，请按以下要求采购。',
    logisticsBoxItem1: '小于60×40×50cm',
    logisticsBoxItem2: '使用7层瓦楞纸制造',
    protectionTitle: '保护材料',
    protectionDescription: '用于保护商品，请按需采购。',
    protectionItem1: '气泡膜',
    protectionItem2: '气柱袋',
    protectionItem3: '缠绕膜',
    protectionItem4: '物流纸箱护角',
    printerTitle: '打印机和标签纸',
    printerDescription: '以下热敏纸和打印机均为必需品。',
    printerItem1: '条码热敏纸：5×3cm',
    printerItem2: '箱唛热敏纸：15×10cm',
    printerItem3: '热敏打印机：装纸宽度应大于10cm',
    cardCreateProductTitle: '在OMS中创建商品',
    cardCreateProductDescription: 'OMS中的一种商品可以是一个单品，也可以是由多个单品组成的套装。',
    noteCreateProduct: '尺寸、重量、申报价格是所有环节自动扣费的依据，请务必准确填写。',
    requiredInfoTitle: '必填信息',
    actionCreateProduct: '创建商品',
    requiredInfoItem1: '产品名称：自定义商品名称',
    requiredInfoItem2: 'SKU：商品自定义编码，建议与电商平台中的商品自定义SKU保持一致',
    requiredInfoItem3: '尺寸：商品包装后的尺寸',
    requiredInfoItem4: '重量：商品包装后的重量',
    requiredInfoItem5: '产品条码：商品EAN/UPC条码（12或13位数字），没有条码的商品此处与SKU保持一致',
    requiredInfoItem6: '申报中文名：必须准确描述商品材质和品类',
    requiredInfoItem7: '申报英文名：必须与申报中文名对应',
    requiredInfoItem8: '申报价格：发生补税和赔付时以此为依据',
    requiredInfoItem9: '原产地：实际生产国',
    requiredInfoItem10: '所属危险品：必须如实选择，特别是带电池商品，不支持修改',
    intlRequiredInfoTitle: '国际物流必填信息',
    actionQueryHsCode: '查询海关编码',
    intlRequiredInfoItem1: '产品图片：真实的商品照片',
    intlRequiredInfoItem2: '产品描述：填写商品材质和品牌名2项信息',
    intlRequiredInfoItem3: '海关编码：准确填写对应的HS编码',
    cardPackageTitle: '商品包装',
    cardPackageDescription: '无论单品或套装，每件商品都必须进行独立包装，达到可以直接发货的状态。',
    notePackage: '为避免产生额外的包装和贴标费用，请严格按照以下要求进行包装。',
    choosePackagingTitle: '任选一种包装材料',
    choosePackagingItem1: '不透明纸箱',
    choosePackagingItem2: '不透明信封',
    choosePackagingItem3: '不透明气泡袋',
    choosePackagingItem4: '不透明快递袋（不推荐）',
    packagingRequirementsTitle: '包装要求',
    packagingRequirementsDescription: '符合要求的包装可以显著降低揽收和运输过程中的漏扫风险。',
    packagingRequirementsItem1: '硬挺不易弯折',
    packagingRequirementsItem2: '易于粘贴和展示快递面单',
    packagingRequirementsItem3: '至少有一个面大于15×10cm',
    cardBarcodeTitle: '粘贴商品条码',
    cardBarcodeDescription: '无论单品或套装，每件商品的包装上都必须粘贴或印刷商品条码。',
    noteBarcode: '为避免产生额外的贴标费用，请确保包装上的商品条码可被扫描，且扫描结果与OMS中的SKU完全一致。',
    sectionChooseBarcodeTitle: '任选一种商品条码',
    omsBarcodeTitle: 'OMS生成的商品条码（推荐）',
    omsBarcodeDescription: '创建商品后在OMS中打印，打印时请使用以下设置，未勾选 Made in China 将面临海关罚款。',
    actionPrintProductBarcode: '打印商品条码',
    omsBarcodeItem1: '打印尺寸：50×30',
    omsBarcodeItem2: '条码类型：二维码',
    omsBarcodeItem3: '编码类型：SKU',
    omsBarcodeItem4: '产品名称：产品名称',
    omsBarcodeItem5: '附加信息：勾选 Made in China',
    omsBarcodeItem6: '打印份数：每件商品粘贴1张',
    nativeBarcodeTitle: '商品自带的EAN或UPC条码',
    nativeBarcodeDescription: '如果商品包装上印有EAN或UPC条码，则不必额外粘贴OMS生成的条码。请确保该条码可被扫描，且扫描结果（12或13位数字）与OMS中的SKU完全一致。',
    sectionPasteBarcodeTitle: '粘贴要求',
    pasteBarcodeDescription: '将商品条码粘贴在包装的平整位置，避免粘贴在转角处，确保商品条码可被扫描。',
    cardBoxingTitle: '商品装箱',
    cardBoxingDescription: '将商品装入物流纸箱并封箱。',
    noteBoxing: '为避免产生额外的清点费用，请严格按照以下要求进行装箱。',
    selectBoxTitle: '选用符合要求的物流纸箱',
    selectBoxItem1: '小于60×40×50cm',
    selectBoxItem2: '使用7层瓦楞纸制造',
    mixedPackingTitle: '混装要求',
    mixedPackingDescription: '每个纸箱最多混装4种商品，且必须同时使用以下2种方法进行分隔。',
    mixedPackingItem1: '使用不同颜色的塑料袋分装不同商品，并在袋外粘贴商品条码。',
    mixedPackingItem2: '使用瓦楞纸、塑料板等坚硬挡板将纸箱隔出多个区域，每区只放一种商品。',
    cardInboundTitle: '在OMS中创建入库单',
    cardInboundDescription: '入库单是你向海外仓发货的唯一凭证，每次发货都必须创建一张入库单。',
    noteInbound: '入库单是国际物流的计费依据，为避免异常扣费，请确保填写的信息与实际装箱情况完全一致。',
    inboundRequiredTitle: '必填信息',
    actionCreateInbound: '创建入库单',
    inboundRequiredItem1: '仓库：选择要入库的的海外仓',
    inboundRequiredItem2: '到仓方式：集装箱整柜到仓选择货柜，其他方式选择箱',
    inboundRequiredItem3: '入库类型：选择常规入库',
    inboundRequiredItem4: '入库产品：先添加箱子，再在箱子中添加产品',
    inboundProductRequirementsTitle: '填写入库产品的要求',
    inboundProductRequirementsDescription: '确保以下信息与实际装箱情况完全一致。',
    inboundProductRequirementsItem1: '箱子数量：描述相同装法的纸箱有几个',
    inboundProductRequirementsItem2: '单箱数量：描述该纸箱中有几个该商品',
    inboundProductRequirementsItem3: '箱子尺寸：完成装箱后的尺寸',
    inboundProductRequirementsItem4: '箱子重量：完成装箱后的重量',
    cardBoxLabelTitle: '粘贴箱唛',
    cardBoxLabelDescription: '打印条码和箱唛，贴在商品和物流纸箱上。',
    noteBoxLabel: '为避免遗失，请严格按照以下要求，在每个物流纸箱上粘贴3种箱唛，每种2张，共计6张。',
    sectionPrintBoxLabelTitle: '打印3种箱唛',
    intlBoxLabelTitle: '国际物流箱唛',
    intlBoxLabelDescription: '提交入库单8小时后联系海海客服获取，并使用10×15cm的热敏纸打印，每个纸箱打印2张。',
    actionContactService: '联系海海客服',
    warehouseBoxLabelTitle: '海外仓箱唛',
    warehouseBoxLabelDescription: '提交入库单后在OMS中打印，打印时请使用以下设置，未勾选 Made in China 将面临海关罚款。',
    actionPrintWarehouseBoxLabel: '打印海外仓箱唛',
    warehouseBoxLabelItem1: '打印范围：按系统默认',
    warehouseBoxLabelItem2: '打印份数：2',
    warehouseBoxLabelItem3: '打印尺寸：100×150',
    warehouseBoxLabelItem4: '列表行高：单行',
    warehouseBoxLabelItem5: '编码类型：系统箱类型号',
    warehouseBoxLabelItem6: '附加信息：勾选 Made in China',
    warehouseBoxLabelItem7: '其他：无需勾选',
    sseeaaBoxLabelTitle: '海海箱唛',
    sseeaaBoxLabelDescription: '点击按钮下载，并使用10×15cm的热敏纸打印，每个纸箱打印2张。',
    actionDownloadSseeaaLabel: '下载海海箱唛',
    sectionPasteBoxLabelTitle: '粘贴要求',
    pasteBoxLabelDescription: '为确保纸箱在堆叠时仍能被识别，每种箱唛必须在每个纸箱上粘贴2张，分别置于纸箱的不同侧面。',
    cardCustomsTitle: '准备报关材料',
    cardCustomsDescription: '海海默认提供双清包税的国际物流服务，海运和空运价格均已包含报关费用和进出口税费，如果你有单独报关需求，请在发货前提供以下6份材料。',
    customsMaterialTitle: '单独报关材料',
    customsMaterialItem1: '货物出口合同',
    customsMaterialItem2: '出口商业发票',
    customsMaterialItem3: '出口货物装箱单',
    customsMaterialItem4: '出口货物报关单',
    customsMaterialItem5: '出口货物报关委托书',
    customsMaterialItem6: '进出口货物规范申报要素',
  },
  en: {
    lockedTitle: 'Prepare your products',
    lockedDescription: 'Get the full preparation guide including material purchasing, packaging, barcode printing, and box-label application to avoid extra overseas costs.',
    lockedFeature1: 'Packaging materials checklist and specs',
    lockedFeature2: 'Standardized packaging workflow',
    lockedFeature3: 'OMS product setup instructions',
    lockedFeature4: 'Inbound order and box-label printing steps',
    actionOpenAccount: 'Open account',
    actionContact: 'Contact support',
    cardPurchaseTitle: 'Purchase consumables',
    notePurchase: 'Overseas labor and consumables are expensive. Complete packaging domestically so overseas warehouses only handle basic receiving and shipping.',
    packagingMaterialsTitle: 'Packaging materials',
    packagingMaterialsDescription: 'Used for product packaging. Packaging should be rigid and not easy to bend, with at least one side larger than 15×10cm.',
    packagingMaterialsItem1: 'Opaque carton box',
    packagingMaterialsItem2: 'Opaque envelope',
    packagingMaterialsItem3: 'Opaque bubble mailer',
    packagingMaterialsItem4: 'Opaque poly mailer (not recommended)',
    logisticsBoxTitle: 'Logistics cartons',
    logisticsBoxDescription: 'Used for international transportation. Purchase based on the following requirements.',
    logisticsBoxItem1: 'Smaller than 60×40×50cm',
    logisticsBoxItem2: '7-layer corrugated cardboard',
    protectionTitle: 'Protective materials',
    protectionDescription: 'Used to protect products. Purchase as needed.',
    protectionItem1: 'Bubble wrap',
    protectionItem2: 'Air column bag',
    protectionItem3: 'Stretch wrap',
    protectionItem4: 'Carton corner guards',
    printerTitle: 'Printer and label paper',
    printerDescription: 'The following thermal papers and printer are required.',
    printerItem1: 'Barcode label paper: 5×3cm',
    printerItem2: 'Box label paper: 15×10cm',
    printerItem3: 'Thermal printer: paper width should be greater than 10cm',
    cardCreateProductTitle: 'Create products in OMS',
    cardCreateProductDescription: 'A product in OMS can be a single item or a bundle composed of multiple items.',
    noteCreateProduct: 'Size, weight, and declared value are used for automatic billing in all stages. Fill in accurately.',
    requiredInfoTitle: 'Required fields',
    actionCreateProduct: 'Create product',
    requiredInfoItem1: 'Product name: custom product name',
    requiredInfoItem2: 'SKU: custom code, recommended to match platform custom SKU',
    requiredInfoItem3: 'Dimensions: packaged product dimensions',
    requiredInfoItem4: 'Weight: packaged product weight',
    requiredInfoItem5: 'Product barcode: EAN/UPC barcode (12 or 13 digits); if unavailable, keep consistent with SKU',
    requiredInfoItem6: 'Declared Chinese name: accurately describe material and category',
    requiredInfoItem7: 'Declared English name: must correspond to Chinese declared name',
    requiredInfoItem8: 'Declared value: used for duty supplementation and compensation',
    requiredInfoItem9: 'Country of origin: actual manufacturing country',
    requiredInfoItem10: 'Dangerous goods category: must be selected truthfully, especially for battery products; not editable later',
    intlRequiredInfoTitle: 'Required for international logistics',
    actionQueryHsCode: 'Query HS code',
    intlRequiredInfoItem1: 'Product image: actual product photo',
    intlRequiredInfoItem2: 'Product description: include material and brand',
    intlRequiredInfoItem3: 'HS code: accurate HS code required',
    cardPackageTitle: 'Product packaging',
    cardPackageDescription: 'For both single items and bundles, each product must be packaged independently and ready for direct shipment.',
    notePackage: 'To avoid extra packaging and labeling fees, follow the requirements strictly.',
    choosePackagingTitle: 'Choose one packaging material',
    choosePackagingItem1: 'Opaque carton box',
    choosePackagingItem2: 'Opaque envelope',
    choosePackagingItem3: 'Opaque bubble mailer',
    choosePackagingItem4: 'Opaque poly mailer (not recommended)',
    packagingRequirementsTitle: 'Packaging requirements',
    packagingRequirementsDescription: 'Compliant packaging significantly reduces missed scans during pickup and transportation.',
    packagingRequirementsItem1: 'Rigid and not easy to bend',
    packagingRequirementsItem2: 'Easy to place and display shipping labels',
    packagingRequirementsItem3: 'At least one side larger than 15×10cm',
    cardBarcodeTitle: 'Apply product barcode',
    cardBarcodeDescription: 'For both single items and bundles, each package must have a printed or pasted product barcode.',
    noteBarcode: 'To avoid extra labeling fees, ensure barcode is scannable and scan result exactly matches SKU in OMS.',
    sectionChooseBarcodeTitle: 'Choose one product barcode',
    omsBarcodeTitle: 'OMS-generated barcode (recommended)',
    omsBarcodeDescription: 'Print in OMS after product creation. Use the settings below; missing "Made in China" may lead to customs penalties.',
    actionPrintProductBarcode: 'Print product barcode',
    omsBarcodeItem1: 'Print size: 50×30',
    omsBarcodeItem2: 'Barcode type: QR code',
    omsBarcodeItem3: 'Encoding type: SKU',
    omsBarcodeItem4: 'Product name: Product name',
    omsBarcodeItem5: 'Additional info: check Made in China',
    omsBarcodeItem6: 'Print copies: 1 per product',
    nativeBarcodeTitle: 'Native EAN/UPC barcode',
    nativeBarcodeDescription: 'If product packaging already has EAN/UPC barcode, OMS barcode is not required. Ensure it is scannable and scan result (12 or 13 digits) exactly matches SKU in OMS.',
    sectionPasteBarcodeTitle: 'Placement requirements',
    pasteBarcodeDescription: 'Place barcode on a flat part of the package, avoid edges/corners, and ensure barcode is scannable.',
    cardBoxingTitle: 'Box packing',
    cardBoxingDescription: 'Pack products into logistics cartons and seal.',
    noteBoxing: 'To avoid extra counting fees, follow packing requirements strictly.',
    selectBoxTitle: 'Use compliant logistics cartons',
    selectBoxItem1: 'Smaller than 60×40×50cm',
    selectBoxItem2: '7-layer corrugated cardboard',
    mixedPackingTitle: 'Mixed packing requirements',
    mixedPackingDescription: 'Each carton can mix up to 4 product types and must use both methods below for separation.',
    mixedPackingItem1: 'Use different color plastic bags for different products and attach product barcode outside each bag.',
    mixedPackingItem2: 'Use rigid partitions (corrugated boards/plastic boards) to separate carton into zones, one product per zone.',
    cardInboundTitle: 'Create inbound order in OMS',
    cardInboundDescription: 'Inbound order is the only proof for shipping to overseas warehouse. Each shipment must have one inbound order.',
    noteInbound: 'Inbound order is the billing basis for international logistics. Ensure form data exactly matches actual packing to avoid abnormal charges.',
    inboundRequiredTitle: 'Required fields',
    actionCreateInbound: 'Create inbound order',
    inboundRequiredItem1: 'Warehouse: select the target overseas warehouse',
    inboundRequiredItem2: 'Arrival type: choose container for full-container shipment, otherwise choose box',
    inboundRequiredItem3: 'Inbound type: choose regular inbound',
    inboundRequiredItem4: 'Inbound products: add cartons first, then add products in each carton',
    inboundProductRequirementsTitle: 'Inbound product entry requirements',
    inboundProductRequirementsDescription: 'Ensure all following fields exactly match actual packing.',
    inboundProductRequirementsItem1: 'Carton quantity: number of cartons with same packing pattern',
    inboundProductRequirementsItem2: 'Quantity per carton: quantity of this product in one carton',
    inboundProductRequirementsItem3: 'Carton dimensions: dimensions after final packing',
    inboundProductRequirementsItem4: 'Carton weight: weight after final packing',
    cardBoxLabelTitle: 'Apply carton labels',
    cardBoxLabelDescription: 'Print product and carton labels, then apply on products and logistics cartons.',
    noteBoxLabel: 'To avoid loss, apply 3 types of carton labels on each carton, 2 copies each (6 total), strictly as required.',
    sectionPrintBoxLabelTitle: 'Print 3 label types',
    intlBoxLabelTitle: 'International logistics label',
    intlBoxLabelDescription: 'Available from SSEEAA support 8 hours after inbound order submission. Print on 10×15cm thermal paper, 2 copies per carton.',
    actionContactService: 'Contact SSEEAA support',
    warehouseBoxLabelTitle: 'Overseas warehouse label',
    warehouseBoxLabelDescription: 'Print from OMS after inbound submission. Use settings below; missing "Made in China" may lead to customs penalties.',
    actionPrintWarehouseBoxLabel: 'Print warehouse labels',
    warehouseBoxLabelItem1: 'Print scope: system default',
    warehouseBoxLabelItem2: 'Print copies: 2',
    warehouseBoxLabelItem3: 'Print size: 100×150',
    warehouseBoxLabelItem4: 'Row height: single line',
    warehouseBoxLabelItem5: 'Code type: system box code',
    warehouseBoxLabelItem6: 'Additional info: check Made in China',
    warehouseBoxLabelItem7: 'Others: no additional checkboxes needed',
    sseeaaBoxLabelTitle: 'SSEEAA label',
    sseeaaBoxLabelDescription: 'Download via button and print on 10×15cm thermal paper, 2 copies per carton.',
    actionDownloadSseeaaLabel: 'Download SSEEAA label',
    sectionPasteBoxLabelTitle: 'Placement requirements',
    pasteBoxLabelDescription: 'To keep cartons identifiable during stacking, apply 2 copies of each label type on different carton sides.',
    cardCustomsTitle: 'Prepare customs documents',
    cardCustomsDescription: 'By default SSEEAA provides duty-paid double-clearance logistics. Sea and air rates include customs declaration and import/export duties. If standalone declaration is needed, provide the 6 documents below before shipping.',
    customsMaterialTitle: 'Standalone customs declaration documents',
    customsMaterialItem1: 'Export contract',
    customsMaterialItem2: 'Commercial invoice',
    customsMaterialItem3: 'Packing list',
    customsMaterialItem4: 'Customs declaration form',
    customsMaterialItem5: 'Customs declaration authorization letter',
    customsMaterialItem6: 'Standardized import/export declaration elements',
  },
};
